import { Component, OnInit } from '@angular/core';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-az-next-cruise',
  templateUrl: './az-next-cruise.component.html',
  styleUrls: [
	'../../assets/css/bootstrap.min.css',
	'../../assets/scss/styles.scss', 
	'../../assets/scss/azamara.scss',
	'../../assets/scss/azamara-l.scss',
	'../../assets/scss/fonts.scss',
	'./az-next-cruise.component.css',
	'../../assets/cssDali/general.scss'
	]
})
export class AzNextCruiseComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("az-next-cruise");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
